<footer>
    <div class="container">
        <div class="row" *ngIf="!consentTokenAvailable">
            <!-- <p  class="col-xs-12 text-center bottom-spc-20">
                By proceeding, I agree to the <a id="link_Terms_Condition" class="hand-cursor" (click)="OpenPopup($event)"> Terms &amp; Conditions </a>,
                <a class="hand-cursor" href="https://www.bajajfinservmarkets.in/legal-and-compliance.html" target="_blank">Terms of Use </a>,
                <a class="hand-cursor" href="https://www.bajajfinservmarkets.in/legal-and-compliance.html#parentHorizontalTab3" target="_blank"> Privacy Policy </a>  and hereby authorize Bajaj Finserv representatives to Call / SMS for this application
                    and other products/services. This consent will override any registration by me for DNC/NDNC.
            </p> -->
            <!-- hiding tag with *ngIf false -->
            <p *ngIf="!securedProductFlag && false" class="col-xs-12 text-center bottom-spc-20 letterspacingpttwo">Minimum annualized percentage rate is 12% and maximum annualized percentage rate is 26% with a flexible repayment period of 12 to 60 months. Also full repayment in 30 days or less is not allowed.
            </p>
            <!-- I accept that I have read, understood &amp; agree to the <a id="link_Terms_Condition" class="hand-cursor"
                    (click)="OpenPopup($event)"> Terms &amp; Conditions </a> and hereby I authorize Bajaj Finserv &amp;
                its representatives to call or SMS me in relation to this application and other
                products/services. This consent will override any registration by me for DNC/NDNC. We will access your
                location from your mobile operator</p> -->
        </div>
    </div>
    <div class="container-fluid footer-info-blocks">
        <div class="row">
            <div class="col-sm-12 col-xs-12">
                <div class="col-md-4 col-sm-12 col-xs-12 info-block-sep">
                    <!-- <img class="bflogo" src="assets/img/White.svg"> -->
                    <img class="bflogo" src="{{bajajMarketsLogo}}">
                    <p class="logo-text-padding">
                        Corporate Identity Number (CIN): U65923PN2014PLC150522.
                    </p>
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12 info-block-sep">
                    <p class="bajaj-finance-limited">
                        <span class="text-style">
                            <!-- {{CompanyName}} Limited Regd. Office -->
                        </span>
                    </p>
                </div>
                <div class="col-md-4 col-sm-12 col-xs-12">
                    <p class="bajaj-finance-limited">
                        <span class="text-style">Bajaj Finserv Direct Limited</span> 4TH Floor, B2 Building, Cerebrum IT Park, Kumar
                        City, Kalyani Nagar, Pune – 411014.
                    </p>
                </div>
            </div>
            <div class="col-sm-12 col-xs-12 BFDL-address">
                <p>
                    Bajaj Finserv Direct Limited ("Bajaj Markets") offers to its customers, various financial products and services through its digital platform as a registered Investment Adviser with SEBI, registered Third-Party App Provider (UPI payments), and as DSA or Digital lending platform of its Partners. Further, Bajaj Markets also offers a marketplace e-commerce platform to facilitate transactions between customers and sellers on-boarded on the platform. Registered Office: Bajaj Auto Limited Complex, Mumbai – Pune Road, Akurdi, Pune – 411 035 CIN: U65923PN2014PLC150522 Investment Adviser, SEBI registration: INA000016083 (Validity - Aug 11, 2021 - Perpetual)
                </p>
            </div>
        </div>
    </div>
    <!-- <div class="container-fluid cust-footer">
        <div class="padding-10-bottom">
            <p class="text-center cust-addr">Bajaj Finserv Direct Limited ("BFDL"), erstwhile Bajaj Financial Holdings Limited is a registered corporate agent
                of Bajaj Allianz Life Insurance Company Limited and Bajaj Allianz General Insurance Company Limited under
                the IRDAI composite registration number CA0551 valid till 10-Apr-2021. BFDL also renders services to Bajaj
                Finance Limited (‘BFL’) in sourcing of customers, providing credit verification activities, fulfilment services
                and post-acquisition portfolio management services related to lending business. </p>
        </div>
    </div> -->
</footer>
<!-- Terms & Conditions Modal need to remove from this page -->
<custom-popup [config]="Config" [title]="'Terms and Conditions'" [showClose]="true" [subtitle]="''" [id]="'termsModal'">
    <!--     <div class="modal-body"> -->
    <div id="dynamicContent" class="modal-body termsConditionDescription">
        <ol class="termsConditionList">
            <li class="bottom-pad-30">
                <span class="terms"></span>
                <span>I declare that all the particulars and information provided by me in this application form are
                    true, correct,
                    complete and up-to-date in all respects and that I have not withheld any information whatsoever.</span>
            </li>
            <li class="bottom-pad-30">
                <span class="terms"></span>
                <span>I confirm that I have/had no insolvency proceedings against me nor have I ever been adjudicated
                    insolvent by
                    any court or other authority and I further confirm that I have read the information on various loan
                    products
                    made available by {{CompanyName}} Limited (hereinafter referred to as “{{CompanyName}}”) on the Website
                    <a href="https://www.bajajfinserv.in/finance" target="_blank">www.bajajfinserv.in/finance</a></span>
            </li>
            <li class="bottom-pad-30">
                <span class="terms"></span>
                <span>I authorize {{CompanyName}} to exchange, share all information and details as provided by me in my
                    application
                    and in relation to my existing loans and/or repayment history to any third party including but not
                    limited
                    to its group companies, service providers, banks, financial institutions, credit bureaus,
                    telecommunication
                    companies, statutory bodies, etc. for customer verification, personalization of products or
                    services, credit
                    rating, data enrichment, marketing or promotion of {{CompanyName}} services or related products or
                    that of
                    its associates and affiliates or for enforcement of your obligations and I shall not hold {{CompanyName}} (or
                    any of its group companies or its/their agents/representatives) liable for the use/sharing of the
                    information
                    as stated above.</span>
            </li>
            <li class="bottom-pad-30">
                <span class="terms"></span>
                <span>I agree and affirm that {{CompanyName}} may contact me and communicate with me over telephonic
                    calls, or SMS on
                    the mobile number mentioned in the application, or through any other communication mode
                    (“Communication Modes”)
                    to verify the details provided by me on the application. Further, I confirm that I would like to
                    know through
                    the above mentioned Communication Modes various {{CompanyName}} loan offer schemes or loan
                    promotional schemes
                    or any other promotional schemes relating to various products/services offered by BFL/its group
                    companies
                    from time to time and hereby authorize BFL, its group companies, employees, agents, associates to
                    contact
                    me from time to time for the same.
                </span></li>
            <li class="bottom-pad-30">
                <span class="terms"></span><span>I agree and confirm that laws in relation to the unsolicited
                    communication referred to in the “National Do Not
                    Call Registry” (the “NDNC Registry”) as laid down by the Telecom Regulatory Authority of India will
                    not be
                    applicable for such communication/calls/ SMSs received from BFL, its group companies, its
                    employees, agents
                    and/or associates.</span></li>
            <li class="bottom-pad-30"><span class="terms"></span><span>I undertake to keep {{CompanyName}} updated of any
                    change in the information provided by me in this application
                    form.</span></li>
            <li class="bottom-pad-30"><span class="terms"></span><span>I understand and acknowledge that {{CompanyName}}
                    shall have the absolute discretion, without assigning any reason
                    to reject my loan application and that {{CompanyName}} shall not be responsible/liable in any manner
                    whatsoever
                    for such rejection.</span>
            </li>
        </ol>
        <p>I further understand and agree that pursuant to this application form, I will be required to submit documents to
            the satisfaction of {{CompanyName}} and accept the loan terms and conditions for availing the loan granted to
            me by {{CompanyName}} from time to time.</p>
        <p class="bottom-pad-50">
            <button type="button" class="close_custom_popup btn btn-block col-md-6 col-md-offset-5 col-sm-6 col-sm-offset-5 col-xs-6 col-xs-offset-4 bottom-pad-30"
                id="close_custom_popup" (click)="ClosePopup($event);PushDataLayerValues($event.currentTarget.id);">Close</button>
        </p>
    </div>
</custom-popup>